// URL parsing utilities
// Extracted from EventPage.tsx for testability and reuse

export function parseTrackUrl(url: string): { provider: 'spotify' | 'itunes'; id: string } | null {
  const spotifyMatch = url.match(/spotify\.com\/track\/([a-zA-Z0-9]+)/) || url.match(/spotify:track:([a-zA-Z0-9]+)/);
  if (spotifyMatch) return { provider: 'spotify', id: spotifyMatch[1] };
  const itunesMatch = url.match(/music\.apple\.com\/.*\/(\d+)/);
  if (itunesMatch) return { provider: 'itunes', id: itunesMatch[1] };
  return null;
}

export function parsePlaylistUrl(url: string): { provider: 'spotify'; id: string } | null {
  const match = url.match(/spotify\.com\/playlist\/([a-zA-Z0-9]+)/)
    || url.match(/spotify:playlist:([a-zA-Z0-9]+)/);
  return match ? { provider: 'spotify', id: match[1] } : null;
}

/** Detect if a URL is a recognized music platform link (any platform). */
export function isMusicPlatformUrl(url: string): boolean {
  return /^https?:\/\/(open\.spotify\.com|music\.apple\.com|spotify\.link|youtu\.?be|music\.youtube\.com|tidal\.com|deezer\.com|amazon\.com|music\.amazon\.com|play\.google\.com)/i.test(url);
}

/** Detect the platform name from a music URL. */
export function detectPlatformFromUrl(url: string): string {
  if (url.includes('spotify.com') || url.includes('spotify.link')) return 'Spotify';
  if (url.includes('music.apple.com') || url.includes('itunes.apple.com')) return 'Apple Music';
  if (url.includes('music.youtube.com') || url.includes('youtu.be')) return 'YouTube Music';
  if (url.includes('tidal.com')) return 'Tidal';
  if (url.includes('music.amazon.com') || url.includes('amazon.com/music')) return 'Amazon Music';
  if (url.includes('deezer.com')) return 'Deezer';
  return 'Unknown';
}
